import styled from '@emotion/styled';
export const Container = styled.div`
  width: ${(props: any) => (props.type ? '150px' : '100%')};
  height: ${(props: any) => (props.type ? '36px' : '50px')};
  border-width: 1px;
  border-radius: ${(props: any) => (props.type ? '6px' : '6px')};
  border-color: ${(props: any) => (props.type ? 'transparent' : '#BDC3D2')};
  border-style: ${(props: any) => (props.type ? 'none' : 'dashed')};
  padding: 0.2em;
  background-color: ${(props: any) => (props.type ? '#1d9aaa' : '')};
  cursor: pointer;
  font-family: 'Roboto';
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${(props: any) =>
    props.type ? 'none' : ''};
  &:hover {
    border-color: ${(props: any) => (props.type ? 'transparent' : '#1D9AAA')};
    background-color: ${(props: any) => (props.type ? '#178a99' : 'rgba(29,154,170,0.03)')};
  }
`;
